import React, { Suspense, lazy } from 'react';
import Loading from '../LoadingComponent';

const SurveyPoints = lazy(() =>
  import(/* webpackChunkName: "SurveyPoints" */ '../../components/rewards/SurveyPoints')
);

export default function SurveyPointsComponent({...props}) {
  return (
    <Suspense fallback={<Loading />}>
      <SurveyPoints {...props} />
    </Suspense>
  );
}
